import { useState } from "react";
import { Check, Minus, ClipboardList } from "lucide-react";
import "./matrix.css";

const TIERS = ["Basic", "Professional", "Premium"];
const DEFAULT_PRICES = { restaurant: [799, 999, 1299], hotel: [999, 1199, 1499] };
const CYCLE_SUFFIX = { monthly: "/mo", half_yearly: "/6 mo", yearly: "/yr" };
const Y = true, N = false;

const COMMON = [
  ["Limits", [
    ["Outlets / branches", "1", "1", "Up to 5"],
    ["Staff logins (OTP)", "3", "15", "Unlimited"],
    ["Menu items", "350", "Unlimited", "Unlimited"],
  ]],
  ["POS & Billing", [
    ["GST billing (5/12/18/28%), invoice link", Y, Y, Y],
    ["Cash / UPI / card payment modes", Y, Y, Y],
    ["Credit billing & customer dues", N, Y, Y],
    ["Bill cancel / reprint with audit", Y, Y, Y],
    ["Table transfer / merge / split", N, Y, Y],
    ["Thermal 58/80 mm + A4 printing", Y, Y, Y],
  ]],
  ["Kitchen", [
    ["KOT generation & print", Y, Y, Y],
    ["KOT modification & history timeline", Y, Y, Y],
    ["Live Kitchen Display (KDS)", N, Y, Y],
  ]],
  ["Inventory & Recipe costing", [
    ["Stock in / out & low-stock alerts", Y, Y, Y],
    ["Recipe cost per serving & food-cost %", Y, Y, Y],
    ["Auto stock depletion on sale (BOM)", N, Y, Y],
    ["Wastage & stock ledger", N, Y, Y],
    ["Stock transfer between outlets", N, N, Y],
  ]],
  ["Purchasing", [
    ["Suppliers & purchase orders", Y, Y, Y],
    ["Supplier ledger & outstanding", N, Y, Y],
    ["Central purchasing", N, N, Y],
  ]],
  ["Customers & Communication", [
    ["Customer database & bill search", Y, Y, Y],
    ["Loyalty points", N, Y, Y],
    ["Customer ledger (bills, payments, dues)", N, Y, Y],
    ["WhatsApp / SMS invoice & daily digest", N, Y, Y],
  ]],
  ["Reports & Accounts", [
    ["Daily sales report", Y, Y, Y],
    ["Insights, GST & item-margin reports", N, Y, Y],
    ["Excel / PDF exports", "PDF only", Y, Y],
    ["Expenses & departmental P&L", N, Y, Y],
    ["Consolidated multi-outlet P&L & comparison", N, N, Y],
  ]],
];

const HOTEL = [
  ["Hotel & Banquets", [
    ["Rooms", "Up to 25", "Up to 100", "Unlimited"],
    ["Halls / banquets", "Up to 2", "Up to 5", "Unlimited"],
    ["Room board, reservations & check-in/out", Y, Y, Y],
    ["Guest folio with payments & refunds", Y, Y, Y],
    ["Hall / banquet bookings", Y, Y, Y],
    ["Charge restaurant bill to room", N, Y, Y],
    ["Occupancy, ADR & RevPAR report", "Basic", Y, Y],
    ["Rooms & hall departments in P&L", N, Y, Y],
  ]],
];

const Cell = ({ v }) => (v === true ? <Check size={15} className="mx-yes" /> : v === false ? <Minus size={15} className="mx-no" /> : <span className="mx-txt">{v}</span>);

export default function ProposedMatrix({ admin, edition, onEdition, prices, cycle = "monthly" }) {
  const [own, setOwn] = useState("restaurant");
  const ed = edition || own;
  const setEd = onEdition || setOwn;
  const groups = ed === "hotel" ? [...COMMON, ...HOTEL] : COMMON;
  const row = prices?.[ed] || DEFAULT_PRICES[ed];
  return (
    <section className="mx-wrap" data-testid="proposed-matrix">
      <div className="mx-head">
        <div>
          <span className="mx-badge" data-testid="proposed-matrix-badge"><ClipboardList size={12} /> LIVE PLAN MATRIX</span>
          <h2>{admin ? "Subscription feature matrix" : "Compare plans"}</h2>
          <p>{admin ? "Approved tiers for both editions — these features and limits are enforced for paying customers." : "Showing the edition selected above. Every plan includes a 14-day free trial."}</p>
        </div>
        <div className="mx-toggle">
          <button className={ed === "restaurant" ? "on" : ""} onClick={() => setEd("restaurant")} data-testid="matrix-edition-restaurant">Restaurant only</button>
          <button className={ed === "hotel" ? "on" : ""} onClick={() => setEd("hotel")} data-testid="matrix-edition-hotel">Restaurant + Hotel</button>
        </div>
      </div>
      <div className="mx-table-wrap"><table className="mx-table" data-testid="matrix-table">
        <thead><tr><th>Feature</th>{TIERS.map((t, i) => <th key={t} className={i === 1 ? "pop" : ""}>{t}<b data-testid={`matrix-price-${t.toLowerCase()}`}>₹{Number(row[i]).toLocaleString("en-IN")}<small>{CYCLE_SUFFIX[cycle]}</small></b></th>)}</tr></thead>
        <tbody>{groups.map(([g, rows]) => [
          <tr key={g} className="mx-group"><td colSpan={4}>{g}</td></tr>,
          ...rows.map(([label, ...vals]) => <tr key={g + label}><td>{label}</td>{vals.map((v, i) => <td key={i} className={i === 1 ? "pop" : ""}><Cell v={v} /></td>)}</tr>),
        ])}</tbody>
      </table></div>
      <p className="mx-foot">Prices include 18% GST. Half-yearly saves 10% and annual saves 20% vs monthly. Nothing is charged until you approve a payment.</p>
    </section>
  );
}
